// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".infomaterials[data-v-d5ed3ac0]{overflow-x:auto}.infomaterials__new-document-card[data-v-d5ed3ac0]{height:200px;width:200px}.infomaterials__file-preview-card[data-v-d5ed3ac0]{max-width:400px;min-width:400px}@media only screen and (max-width:599.98px){.infomaterials__file-preview-card[data-v-d5ed3ac0]{max-width:330px;min-width:330px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
